<template>
  <main :class="classes">
    <div class="container">

      <div class="view-checkout-confirm__content">
        <!-- Cart -->
        <section class="view-checkout-confirm__cart checkout-cart">
          <div class="view-checkout-confirm__cart-header">
            <h1 class="view-checkout-confirm__title">{{$t('sayl-oat.checkout_confirm_title')}}</h1>
            <h1 class="view-checkout-confirm__subtitle">{{ $t('sayl-oat.checkout_confirm_cart_title', { service: orderService }) }}</h1>
            <div class="view-checkout-confirm__code">{{ $t('sayl-oat.checkout_confirm_cart_subtitle', { code: orderCode }) }}</div>
          </div>

          <div class="view-checkout-confirm__cart-body">
            <cart />
          </div>
        </section>

        <!-- Social -->
        <section 
          v-if="shop.socials.length"
          class="view-checkout-confirm__social">

          <div class="col view-checkout-confirm__social-body">
            <!-- Header -->
            <header class="view-checkout-confirm__social-header">
              <h2 class="view-checkout-confirm__social-title">{{ $t('sayl-oat.checkout_confirm_socials_title') }}</h2>
              <p class="view-checkout-confirm__social-description">{{ $t('sayl-oat.checkout_confirm_socials_description') }}</p>
            </header>

            <!-- Newsletter -->
            <form v-if="!signup" class="view-checkout-confirm__social-form">
              <forms-input 
                class="view-checkout-confirm__social-input"
                :placeholder="$t('sayl-oat.email_placeholder')"
                v-model="email">{{ $t('sayl-oat.email') }}</forms-input>
              
              <actions-button 
                v-if="email"
                class="view-checkout-confirm__social-cta" 
                appearance="primary" 
                size="s"
                @click.stop.prevent="onSignup">{{ $t('sayl-oat.button_signup') }}</actions-button>
            </form>

            <div v-else>
              <span class="view-checkout-confirm__social-signup">{{ $t('sayl-oat.signup_thanks') }}</span>
            </div>

            <!-- Social media -->
            <div class="view-checkout-confirm__social-content">
              <ul class="view-checkout-confirm__social-list">
                <li
                  v-for="item in socials" 
                  :key="item.type"
                  class="view-checkout-confirm__social-item">
                  <a 
                    class="view-checkout-confirm__social-link"
                    :href="item.href"
                    :title="item.label">
                    <img 
                      :src="item.icon" 
                      :alt="item.label" 
                      class="view-checkout-confirm__social-logo">
                    
                    <div class="view-checkout-confirm__social-label">{{ item.label }}</div>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- <div class="col view-checkout-confirm__social-illustration">
            <img src="/statics/images/social.png" alt="follow us on social media">
          </div> -->
        </section>
      </div>

      <div class="view-checkout-confirm__footer">
        <div class="checkout-cart__footer">
          <actions-button
            :href="{name: 'sayl-oat-catalog.catalog'}"
            icon-pre="arrow-left"
          >{{ $t('sayl-oat.back_button') }}</actions-button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Cart from '@/components/checkout/cart'

export default {
  name: 'CheckoutConfirm',
  
  components: {
    Cart
  },

  data() {
    return { 
      email: null,
      optin: true,
      signup: false,
    }
  },

  computed: {
    ...mapState({
      order: state => state['sayl-oat'].order,
      shop: state => state['sayl-oat'].shop,
      user: state => state['sayl-oat.user'].user,
    }),

    classes(){
      return {
        'view-checkout-confirm__body': true,
      };
    },

    orderCode() {
      return this.order !== null ? this.order.pickup_code : '[DEV] - CODE';
    },

    orderService() {
      return this.order !== null ? this.order.service : '[DEV] - Eatin';
    },

    socials() {
      let ret = [];

      if (!this.loading && this.shop.socials){
        ret = this.shop.socials.filter( s => s.href != null );
        ret.forEach( s => {
          if (['twitter', 'messenger'].includes(s.type)){
            s.label = '@' + s.label;
          }
        })
      }

      return ret;
    }
  },

  methods: {
    ...mapActions({
      reset: 'reset',
      getOrder: 'getOrder',
      updateUser: 'sayl-oat.user/update',
    }),

    onSignup() {
      if(this.email !== null) {
        const user = {
          firstname: this.user.firstname,
          lastname: this.user.lastname,
          email: this.email,
          phone: '1234567890', 
          opt_in: this.optin,
        };

        if(['', null, undefined].includes(user.firstname)) {
          user.firstname = 'John';
        }

        if(['', null, undefined].includes(user.lastname)) {
          user.lastname = 'Doe';
        }

        this.updateUser(user).then((u) => { 
          this.signup = true;
        }).catch((error) => {
          console.error(error)
        });
      } else {
        this.setTableNumber(this.value);
        this.$emit('close');
      }
    }
  },

  mounted() {
    if(this.user.contact_email !== null) {
      this.email = this.user.contact_email;
    }

    if(['', undefined, null].includes(this.$route.params.id)) {
      this.$router.push({name: 'sayl-oat-catalog.catalog'})
    } 
    
    this.getOrder({ order_id: this.$route.params.id }).catch((error) => {
      console.error(error);
      // this.$router.push({name: 'sayl-oat-catalog.catalog'});
    });
  },

  beforeDestroy: function(next) {
    this.reset().then(() => {
      this.$bus.$emit('sayl-oat.reset');
    });
  },
}
</script>
